import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import PlayAudio from '../news/PlayAudio';

class SpecificStockNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockNewsList: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getStockNews(this.state.limit, this.state.symbol)
            .then(result => {
                console.log('SPecific StockNews', result);
                this.setState({ stockNewsList: result });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        return (
            <tr key={listValue.url + Math.random()}>
                <td><a href={listValue.url} target="_blank" rel="noreferrer">
                    <img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" />
                </a>
                </td>
                <td style={{ textAlign: 'left' }} >
                    <div><a href={listValue.url} target="_blank" rel="noreferrer">{listValue.title}</a></div>
                    <div style={{ fontSize: '10px' }}>{listValue.publishedDate}</div>
                    <div style={{ fontSize: '15px' }}>{listValue.text} <PlayAudio text={listValue.text}/></div>
                </td>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.stockNewsList === undefined || this.state.stockNewsList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            tableRow = this.state.stockNewsList.map(this.renderRow.bind(this));
        }        
        let header = 'Latest News/Articles';
        header = <><Link to={'/news/'+this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/news/'+this.state.symbol}>(See More)</Link></>
        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" responsive>
                    <thead>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
                <Link style={{ fontSize: "10px", fontWeight: 'bold' }} to={'/news/'+this.state.symbol}>See More News...</Link>
            </div>
        );
    }
}

export default SpecificStockNews;
